export default __webpack_public_path__ + "static/framer3-86acee1ff7d45d91184b0f7bf48adc72.jpg";